export default function getMeasureMappings(): any {
  const measureMappings: any = {};
  return measureMappings;

}
